<template>
  <div>
    <span class="block text-xs font-semibold text-gray-600 dark:text-gray-300 mb-1">{{ label }}</span>
    <ul class="space-y-1.5">
      <li v-for="(bullet, index) in modelValue" :key="index" class="flex items-start gap-1.5">
        <span class="mt-3 w-1 h-1 rounded-full bg-gray-400 flex-shrink-0" aria-hidden="true"></span>
        <textarea :value="bullet" @input="update(index, $event.target.value)" rows="2" maxlength="500" :placeholder="placeholder" :aria-label="`${label} ${index + 1}`"
          class="flex-1 px-3 py-2 text-sm rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-[#0d1117] text-gray-900 dark:text-gray-100 placeholder-gray-400 dark:placeholder-gray-500 resize-y focus:outline-none focus:ring-2 focus:ring-blue-500/40 focus:border-blue-400"></textarea>
        <button type="button" :aria-label="`Remove ${label.toLowerCase()} ${index + 1}`" @click="remove(index)"
          class="mt-1.5 w-7 h-7 flex-shrink-0 inline-flex items-center justify-center rounded-md text-gray-400 hover:text-red-600 hover:bg-red-50 dark:hover:bg-red-900/20">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="1.75" viewBox="0 0 24 24" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/></svg>
        </button>
      </li>
    </ul>
    <button v-if="modelValue.length < max" type="button" @click="add"
      class="mt-1.5 inline-flex items-center gap-1 h-7 px-2 rounded-md text-xs font-semibold text-blue-600 dark:text-blue-400 hover:bg-blue-50 dark:hover:bg-blue-900/20">
      <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15"/></svg>
      Add a line
    </button>
  </div>
</template>

<script setup>
const props = defineProps({
  modelValue: { type: Array, default: () => [] },
  label: { type: String, required: true },
  placeholder: { type: String, default: '' },
  max: { type: Number, default: 12 }, // ResumeContent::MAX_BULLETS
})
const emit = defineEmits(['update:modelValue'])

const add = () => emit('update:modelValue', [...props.modelValue, ''])
const remove = (index) => emit('update:modelValue', props.modelValue.filter((_, i) => i !== index))
const update = (index, value) => emit('update:modelValue', props.modelValue.map((bullet, i) => (i === index ? value : bullet)))
</script>
